import React, { useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorContainer from "../../../Components/ErrorContainer";
import Input from "../../../Components/Input";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { actions } from "../../../../Redux";
import Select from "../../../Components/Select";
import { objToArr } from "../../../../helpers";
import ModelContainer from "../../../Components/ModelContainer";

const IntegrationsEdit = () => {
  const dispatch = useDispatch();
  const editData = useSelector(
    (state) => state?.settingReducer?.integrationEditData
  );

  useEffect(() => {
    dispatch(actions?.getIntegrationEditData());
  }, []);
  const pauseModalState = useSelector(
    (state) => state?.settingReducer?.pause_store_modal
  );
  const setPauseModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "pause_store_modal",
        modalState: state,
      })
    );
  const [category, setCategory] = useState("");
  const editDefaultState = {
    grabfood_store_id: editData?.integrationPackage?.grabfood_store_id ?? "",
    sales_type_name: editData?.integrationPackage?.sales_type_name ?? "",
    pos_master_id: editData?.integrationPackage?.pos_master_id ?? "",
    payment_method_id: editData?.integrationPackage?.payment_method_id ?? "",
    sales_type_id: editData?.integrationPackage?.sales_type_id ?? "",
    status: editData?.integrationPackage?.status ?? "",
    auto_fire: editData?.integrationPackage?.order_auto_fire ?? "",
    agreed_fee: editData?.integrationPackage?.agreed_fee ?? "",
    inherit_sales_type_menu:
      editData?.integrationPackage?.inherit_sales_type_menu ?? "",
    // push_menu_input: editData?.integrationPackage?.push_menu_input ?? "",
  };
  const schema = yup.object().shape({
    grabfood_store_id: yup.string().required(),
    sales_type_name: yup.string().required(),
    pos_master_id: yup.string().required(),
    payment_method_id: yup.string().required(),
    sales_type_id: yup.string().required(),
    status: yup.string().required(),
    auto_fire: yup.string().required(),
    agreed_fee: yup.string().required(),
    inherit_sales_type_menu: yup.string().required(),
    // push_menu_input: yup.string().required(),
  });
  useEffect(() => {
    console.log(editDefaultState, "pppppp");
    reset(editDefaultState);
  }, [editData]);
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: editDefaultState,
  });

  function submitData(data) {
    console.log({ ...category, ...data }, "lllllll");
    dispatch(actions?.postIntegrationEditData({ ...category, ...data }));
  }
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="shadowclass">
              <div className="d-flex justify-content-between mb-3 align-items-center p-2">
                <h4 class="event-alert p-0 m-0">
                  Grabfood Integration Details
                </h4>
                
                  <button
                    onClick={() => {
                      setPauseModalState(true);
                    }}
                    class="btn btn_btnblue pull-right"
                    type="button"
                    id="pause-store"
                  >
                    Temp Pause Store
                  </button>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
                className="row mx-0 px-0 justify-content-between align-items-center"
              >
                {" "}
                {console.log(errors)}
                <div class="col-md-6">
                  <ul className="ingredient-info edit-shift">
                    <Input
                      label={"Grabfood store ID"}
                      formRegister={register}
                      formError={errors}
                      formKey="grabfood_store_id"
                    />
                    <Input
                      label={"Sales Type Name"}
                      formRegister={register}
                      formError={errors}
                      formKey="sales_type_name"
                    />

                    <Select
                      label={"Default Order Station"}
                      formRegister={register}
                      formError={errors}
                      formKey="pos_master_id"
                      optionsArray={objToArr(editData?.posMaster)}
                    />
                    <Select
                      label={"Linked Pay Method"}
                      formRegister={register}
                      formError={errors}
                      formKey="payment_method_id"
                      optionsArray={objToArr(editData?.methodTypes)}
                    />
                    <Select
                      label={"Inherited Sales Type"}
                      formRegister={register}
                      formError={errors}
                      formKey="sales_type_id"
                      optionsArray={objToArr(editData?.sales_type_list)}
                    />
                  </ul>
                </div>
                <div class="col-md-6">
                  <ul className="ingredient-info edit-shift">
                    <Select
                      label={"Status"}
                      formRegister={register}
                      formError={errors}
                      formKey="status"
                      optionsArray={[
                        { value: "active", label: "Active" },
                        { value: "pending", label: "Pending" },
                      ]}
                    />
                    <Select
                      label={"Auto-Fire Orders?"}
                      formRegister={register}
                      formError={errors}
                      formKey="auto_fire"
                      optionsArray={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                    />
                    <Input
                      label={"Agreed Fee %"}
                      formRegister={register}
                      formError={errors}
                      formKey="agreed_fee"
                    />
                    <Select
                      label={"Inherit Sales Type Menu?"}
                      formRegister={register}
                      formError={errors}
                      formKey="inherit_sales_type_menu"
                      optionsArray={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                    />
                    <Select
                      label={"Categorisation Preference "}
                      formRegister={register}
                      formError={errors}
                      formKey="as"
                      optionsArray={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                    />
                  </ul>
                </div>
                <MenuSequencing setCategory={setCategory} category={category} />
                <div className="clearfix"> &nbsp; </div>
                <div class="btns d-flex justify-content-end">
                  <button class="btn" name="submit" type="submit" id="cancel">
                    Cancel
                  </button>
                  <button
                    onClick={handleSubmit(submitData)}
                    class="btn"
                    name="submit"
                    type="submit"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <PauseStore
          pauseModalState={pauseModalState}
          setPauseModalState={setPauseModalState}
        />
      </div>
    </UserInterface>
  );
};

const MenuSequencing = ({ setCategory }) => {
  const dispatch = useDispatch();
  const menuData =
    useSelector(
      (state) => state?.settingReducer?.integrationEditData?.menudata
    ) ?? null;
  const [copiedMenuData, setCopiedMenuData] = useState();
  // console.log(copiedMenuData, "copiedMenuData");

  useEffect(() => {
    setCopiedMenuData(menuData);
  }, [menuData]);

  function handleSectionActivation(sectionId) {
    const updatedMenuData = copiedMenuData?.map((sectionEl) => {
      if (sectionId === sectionEl?.id)
        return {
          ...sectionEl,
          status: sectionEl?.status === "0" ? "1" : "0",
          items: sectionEl?.items?.map((menuItem) => ({
            ...menuItem,
            status: sectionEl?.status === "0" ? "1" : "0",
          })),
        };
      else return sectionEl;
    });
    console.log(updatedMenuData, "ppppppppppp", copiedMenuData);
    setCopiedMenuData(updatedMenuData);
  }

  function handleMenuActivation(menuId) {
    let itemFound = false;
    const updatedMenuData = copiedMenuData?.map((sectionEl) => ({
      ...sectionEl,
      items: sectionEl?.items?.map((menuItem) => {
        if (itemFound === false && menuItem?.id === menuId) {
          itemFound = true;
          return {
            ...menuItem,
            status: menuItem?.status === "0" ? "1" : "0",
          };
        } else {
          return menuItem;
        }
      }),
    }));

    updatedMenuData?.forEach((sectionEl) => {
      if (sectionEl?.items?.some((menuItem) => menuItem?.status === "1")) {
        sectionEl["status"] = "1";
      } else {
        sectionEl["status"] = "0";
      }
    });
    setCopiedMenuData(updatedMenuData);
    console.log("updatedMenu", updatedMenuData);
  }

  function handleMoveSection(direction, targetId) {
    const deepCopiedData = JSON.parse(JSON.stringify(copiedMenuData));
    const targetIdx = deepCopiedData?.findIndex(
      (section) => section?.id === targetId
    );

    console.log(targetIdx, "hhhhhhhhhhhhhhhhh");

    if (targetIdx < 0) return;

    if (direction === "up") {
      if (targetIdx === 0) return;
      const upperSequence = deepCopiedData[targetIdx - 1]?.sequence;
      const currSequence = deepCopiedData[targetIdx]?.sequence;

      deepCopiedData[targetIdx]["sequence"] = upperSequence;
      deepCopiedData[targetIdx - 1]["sequence"] = currSequence;
    } else {
      if (targetIdx === deepCopiedData?.length - 1) return;
      const lowerSequence = deepCopiedData[targetIdx + 1]?.sequence;
      const currSequence = deepCopiedData[targetIdx]?.sequence;

      deepCopiedData[targetIdx]["sequence"] = lowerSequence;
      deepCopiedData[targetIdx + 1]["sequence"] = currSequence;
    }
    console.log(deepCopiedData, "deepCopiedData");
    const finalData = deepCopiedData.sort((a, b) => a.sequence - b.sequence);
    setCopiedMenuData(finalData);
  }

  function handleMoveMenu(direction, targetMenuId, targetSectionId) {
    const deepCopiedMenuData = JSON.parse(JSON.stringify(copiedMenuData));

    const sectionIdx = deepCopiedMenuData?.findIndex(
      (section) => section.id === targetSectionId
    );

    const menuIdx = deepCopiedMenuData[sectionIdx]?.items?.findIndex(
      (menu) => menu?.id === targetMenuId
    );

    if (menuIdx < 0) return;

    if (direction === "up") {
      if (menuIdx === 0) return;

      const currentMenuSeq =
        deepCopiedMenuData[sectionIdx]?.items[menuIdx]?.sequence;
      const upperMenuSeq =
        deepCopiedMenuData[sectionIdx]?.items[menuIdx - 1]?.sequence;
      console.log(
        deepCopiedMenuData[sectionIdx]?.items[menuIdx]["sequence"],
        "mmmmmmmmmmmmm"
      );

      const targetArr = deepCopiedMenuData[sectionIdx]?.items;
      targetArr[menuIdx]["sequence"] = upperMenuSeq;
      targetArr[menuIdx - 1]["sequence"] = currentMenuSeq;
    }
    if (direction === "down") {
      if (menuIdx === deepCopiedMenuData[sectionIdx]?.items.length - 1) return;

      const currentMenuSeq =
        deepCopiedMenuData[sectionIdx]?.items[menuIdx]?.sequence;
      const lowerMenuSeq =
        deepCopiedMenuData[sectionIdx]?.items[menuIdx + 1]?.sequence;
      console.log(
        deepCopiedMenuData[sectionIdx]?.items[menuIdx]["sequence"],
        "mmmmmmmmmmmmm"
      );

      const targetArr = deepCopiedMenuData[sectionIdx]?.items;
      targetArr[menuIdx]["sequence"] = lowerMenuSeq;
      targetArr[menuIdx + 1]["sequence"] = currentMenuSeq;
    }
    deepCopiedMenuData?.forEach((sectionEl) => {
      sectionEl?.items?.sort((a, b) => a.sequence - b.sequence);
    });
    console.log(deepCopiedMenuData, "mmmmmmmmmmmmm");
    setCopiedMenuData(deepCopiedMenuData);
  }

  function handleSubmit() {
    const data = {
      push_menu_input: "yes",
      category: copiedMenuData?.map((sectionItem) => {
        return {
          id: sectionItem?.id,
          sequence: sectionItem?.sequence,
          // status: sectionItem?.status,
          menu: sectionItem?.items?.map((menuItem) => ({
            category_id: sectionItem?.id,
            id: menuItem?.id,
            sequence: menuItem?.sequence,
            // status: menuItem?.status,
          })),
        };
      }),
    };
    return data;
    console.log(data);
  }
  useEffect(() => {
    setCategory(handleSubmit());
  }, [copiedMenuData]);
  return (
    <div className="shadowclass mt-md-4 mt-3 integrationEditMs">
      <h4 class="event-alert"> Ordrr QR Menu &amp; Sequencing </h4>
      <div className="row mx-0">
        <div className="table-responsive min-width-table">
          <table id="menu_sequencing" class="checklist-table remove-space">
            <thead>
              <tr>
                <th className="col-1 text-right"> Sequence ID </th>
                <th className="col-2"> Sequence Type </th>
                <th className="col-3"> Menu Name </th>
                <th className="col-5"> </th>
              </tr>
            </thead>
            <tbody id="menu_sequencing_body">
              {copiedMenuData?.map((sectionItem, sectionIdx) => (
                <tr>
                  <td colspan="4" className="p-0">
                    <table class="table category-table">
                      <tr class="categ-tr activerow">
                        <td class="col-1 align-right">
                          {sectionIdx + 1}-00000
                        </td>
                        <td className="col-2"> Sub-Category</td>
                        <td className="col-3"> {sectionItem?.name}</td>
                        <td className="col-5 btns-table-sec">
                          <button
                            onClick={() => {
                              handleMoveSection("up", sectionItem?.id);
                            }}
                            type="button"
                            class="btn_btnblue categoryup"
                          >
                            Move Up Section
                          </button>
                          <button
                            onClick={() => {
                              handleMoveSection("down", sectionItem?.id);
                            }}
                            type="button"
                            class="btn_btnblue categorydown"
                          >
                            Move Down Section
                          </button>
                          {/* <button
                            onClick={() =>
                              handleSectionActivation(sectionItem?.id)
                            }
                            type="button"
                            class={`btn_btnblue categorystatus ${
                              sectionItem?.status == 1
                                ? "deactivate"
                                : "activate"
                            }`}
                          >
                            {sectionItem?.status == 1
                              ? "Dectivate"
                              : "Activate"}
                          </button> */}
                        </td>
                      </tr>
                      {sectionItem?.items?.map((menuItem, menuIdx) => {
                        return (
                          <tr class="menutr category-0 activerow">
                            <td class="menu col-1">
                              {" "}
                              {sectionIdx + 1}-0000{menuIdx + 1}{" "}
                            </td>
                            <td className="col-2">MenuItems</td>
                            <td className="col-3">
                              {menuItem?.name}
                              (1-for-1)
                            </td>
                            <td className="col-5 btns-table-sec">
                              <button
                                onClick={() => {
                                  handleMoveMenu(
                                    "up",
                                    menuItem?.id,
                                    sectionItem?.id
                                  );
                                }}
                                type="button"
                                class="btn_btnblue menuup"
                              >
                                Move Up Item
                              </button>
                              <button
                                onClick={() => {
                                  handleMoveMenu(
                                    "down",
                                    menuItem?.id,
                                    sectionItem?.id
                                  );
                                }}
                                type="button"
                                class="btn_btnblue menudown"
                              >
                                Move Down Item
                              </button>
                              {/* <button
                                onClick={() => {
                                  handleMenuActivation(menuItem?.id);
                                }}
                                type="button"
                                class={`btn_btnblue categorystatus ${
                                  menuItem?.status == 1
                                    ? "deactivate"
                                    : "activate"
                                }`}
                              >
                                {menuItem?.status == 1
                                  ? "Deactivate"
                                  : "Activate"}
                              </button> */}
                            </td>
                          </tr>
                        );
                      })}
                    </table>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const PauseStore = ({ pauseModalState, setPauseModalState }) => {
  const dispatch = useDispatch();
  const editData = useSelector(
    (state) => state?.settingReducer?.integrationEditData
  );
  const addDefaultState = {
    is_pause: "",
    pause_time: "",
  };
  const [isPause, setIsPause] = useState("pause");
  const schema = yup.object({
    is_pause: yup.string().required(),
    pause_time: yup.string().required(),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: addDefaultState,
  });

  function submitData(data) {
    dispatch(
      actions?.postPauseStore({
        ...data,
        partner_store_id: editData?.merchantStores?.partner_store_id,
        store_id: editData?.merchantStores?.id,
      })
    );
  }

  return (
    <ModelContainer
      title={"Temp Pause Store"}
      open={pauseModalState}
      closeModal={() => {
        dispatch(actions?.saveConfirmPasswordStatus(false));
        setPauseModalState(!pauseModalState);
      }}
      submitModal={handleSubmit(submitData)}
    >
      {console.log(getValues(), errors, "lllll")}
      <form>
        <ul className="form-list label-group">
          <Select
            label={"Is Pause"}
            formRegister={register}
            formError={errors}
            formKey={"is_pause"}
            onChange={(e) => {
              setIsPause(e.target.value);
            }}
            optionsArray={[
              { value: "pause", label: "Pause" },
              { value: "unpause", label: "Unpause" },
            ]}
          />
          {isPause === "pause" && (
            <Input
              label={"Pause Time"}
              formRegister={register}
              formError={errors}
              formKey={"pause_time"}
            />
          )}
        </ul>
      </form>
    </ModelContainer>
  );
};

export default IntegrationsEdit;
